// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/footer.scss
// module id = 20
// module chunks = 0